export interface GenericUser {
    ad_est_actif: boolean
    ad_personne_id: number
    ad_user_ou: string
    classes: string[]
    courriel: string
    courriel_alias: string
    courriel_autre: string
    date_debut: Date
    date_fin: Date
    date_validite: Date
    date_naissance?: string
    description: string
    etablissement_id: string
    etablissement_nom: string
    etablissements: string[]
    etat_ad: string
    etat_refedu: string
    fonctions: string
    groupes: string[]
    hasResetPassword: boolean
    identifiant: string
    nom: string
    password: string
    personne_id: number
    prenom: string
    refedu: boolean
    services: string[]
    source: string
    titre: string
    wifi: boolean
    wifiCSV: string
    years: string[]
}

export interface User {
    ad_personne_id: number
    prenom: string
    nom: string
    identifiant: string
    wifi: boolean
    wifiCSV: string
    courriel: string
    courriel_autre: string
    fonctions: string
    ad_est_actif: boolean
    etablissement_id: string
    etablissement_nom: string
    years: string[]
    classes: string[]
    groupes: string[]
    services: string[]
    password: string
    hasResetPassword: boolean
}

export interface AccountWaitingForSync {
    personne_id: number
    prenom: string
    nom: string
    identifiant: string
    courriel: string
    courriel_secondaire: string
    etablissement_id: number
}

export interface SchoolStaffNonNormalized {
    personne_id: number
    prenom?: string
    nom?: string
    identifiant?: string
    courriel?: string
    courriel_secondaire?: string
    etablissement_id?: number
}

export interface TeacherNonNormalized {
    personne_id: number
    prenom?: string
    nom?: string
    identifiant?: string
    courriel?: string
    courriel_secondaire?: string
    etablissement_id?: number
}

export interface SubstituteNonNormalized {
    personne_id: number
    prenom?: string
    nom?: string
    identifiant?: string
    courriel?: string
}

export interface StudentNonNormalized {
    personne_id: number
    prenom?: string
    nom?: string
    etablissement_id?: number
}

export interface UnknownNonNormalized {
    personne_id: number
    prenom?: string
    nom?: string
}

export interface Extra {
    personne_id: number
    nom: string
    prenom: string
    genre: string
    date_naissance: string
    personne_ia_id: number
    personnel_id: number
    iup: string
    tel_mobile: string
    tel_prive: string
    tel_prof: string
    courriel: string
    courriel_autre: string
    licence: string
    authority: string | null
    department: string | null
    entity: string | null
    unit: string | null
    data_steward: boolean
    fonction: string
    school_ids: number[]
    source: string
    identifiant: string
}

export class GuestSchool {
    public id: number
    public comment: string
    public function: string
    public school_id: number
    public enabled: boolean
    public creation_date: string

    constructor(comment: string, functionName: string, school_id: number, creation_date: string, id: number) {
        this.comment = comment
        this.function = functionName
        this.school_id = school_id
        this.creation_date = creation_date
        this.id = id
    }
}

export class GuestForTable {
    public id: number
    public guest_id: number
    public id_school_db: number
    public first_name: string
    public last_name: string
    public email: string
    public comment: string
    public function: string
    public school_id: number
    public invitation_type: string
    public authentication_type: string
    public synchronized: boolean
    public creation_date:string

    constructor(id: number, guest_id: number, first_name: string, last_name: string, email: string, comment: string, functionName: string, school_id: number, invitation_type: string, authentication_type: string, synchronized: boolean, creation_date:string, id_school_db:number) {
        this.id = id
        this.guest_id = guest_id
        this.first_name = first_name
        this.last_name = last_name
        this.email = email
        this.comment = comment
        this.function = functionName
        this.school_id = school_id
        this.invitation_type = invitation_type
        this.authentication_type = authentication_type
        this.synchronized = synchronized
        this.creation_date = creation_date
        this.id_school_db = id_school_db
    }
}


export default class GuestUser {
    public id: number
    public first_name: string
    public last_name: string
    public email: string
    public guest_school: GuestSchool[]
    public invitation_type: string
    public authentication_type: string
    public synchronized: boolean


    constructor(
        id: number,
        first_name: string,
        last_name: string,
        email: string,
        guest_school: GuestSchool[],
        invitation_type: string,
        authentication_type: string,
        synchronized: boolean, 
    ) {
        this.id = id
        this.first_name = first_name
        this.last_name = last_name
        this.email = email
        this.guest_school = guest_school
        this.invitation_type = invitation_type
        this.authentication_type = authentication_type
        this.synchronized = synchronized
    }
}

